import React from "react";
import img1 from './images/pexels-nimit-kansagra-4509131.jpg';

export default function Coding() {
    return(
        <div>
        <img src={img1} alt="coding" />
        </div>
    );
}
